import { Waves, CircleDot, Dumbbell, Trees, PartyPopper, CarFront } from "lucide-react";

const items = [
  { icon: Waves, title: "Piscina", desc: "Zona de lazer com piscina comum e jardim envolvente, concebida para momentos de relaxamento e convívio.", meta: "Piscina 80m² · Jardim 180m²" },
  { icon: CircleDot, title: "Court de Padel", desc: "Campo de padel exterior com pavimento de alta qualidade para a prática desportiva regular ou informal.", meta: "Área total 570m²" },
  { icon: Dumbbell, title: "Ginásio", desc: "Espaço interior equipado com cardio, pesos livres e zona de alongamentos para treino individual ou em grupo.", meta: "Uso exclusivo dos residentes" },
  { icon: Trees, title: "Jardim de 4 000m²", desc: "O maior jardim residencial de Cantanhede, com percursos pedonais e reaproveitamento de águas pluviais.", meta: "Sustentável · Privado · Exclusivo", highlight: true },
  { icon: PartyPopper, title: "Sala Polivalente", desc: "Espaço multiusos para reuniões, festas e eventos privados, equipado com kitchenette e balneários.", meta: "60m² · Kitchenette · Arrumos" },
  { icon: CarFront, title: "Estacionamento Privativo", desc: "66 lugares em cave subterrânea, distribuídos pelos três blocos, com infraestrutura para veículos elétricos.", meta: "66 lugares · Carregamento elétrico" },
];

export default function Amenities() {
  return (
    <section id="amenidades" data-testid="amenities-section" className="relative bg-[#F1F1EC] py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end mb-12 lg:mb-20">
          <div className="lg:col-span-7 reveal">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#5C5C59] mb-6">Espaços Comuns</div>
            <h2 className="font-display text-[36px] sm:text-[44px] lg:text-[56px] leading-[1.05] tracking-[-0.02em] text-[#1A1A1A] text-balance">
              Espaços pensados
              <br />
              <span className="italic-display text-[#2B3B31]">para a comunidade.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 reveal" style={{ transitionDelay: "120ms" }}>
            <p className="text-[15px] leading-relaxed text-[#5C5C59] font-light">
              Um conjunto de amenidades raras num condomínio desta escala — pensadas para que o dia-a-dia tenha a textura de um pequeno resort privado.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E5DF] border border-[#E5E5DF]">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`amenity-${i}`}
                className={`relative bg-[#F9F9F6] p-8 lg:p-10 group transition-colors duration-500 hover:bg-white reveal`}
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="flex items-center justify-between mb-8">
                  <Icon size={28} strokeWidth={1.25} className="text-[#2B3B31]" />
                  <span className="text-[11px] tracking-[0.24em] uppercase text-[#9E9789]">0{i + 1}</span>
                </div>
                <h3 className="font-display text-2xl lg:text-3xl text-[#1A1A1A] mb-3">{it.title}</h3>
                <p className="text-[14px] leading-relaxed text-[#5C5C59] mb-6 min-h-[60px]">{it.desc}</p>
                <div className="pt-4 border-t border-[#E5E5DF] text-[11px] tracking-[0.18em] uppercase text-[#2B3B31]">
                  {it.meta}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
